import BaseModel from './baseModel';
import ToggleFeatureModel from './toggleFeatureModel';

const Models = {
  BaseModel,
  ToggleFeatureModel,
};

export default Models;
